var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a",
    {
      staticClass: "c-headerLogo",
      class: _vm.flat ? "c-headerLogo--flat" : "",
      attrs: { tabindex: "0", href: _vm.url ? _vm.url : _vm.redirectMainRoute },
    },
    [
      _c(
        "picture",
        {
          staticClass: "c-headerLogo_image",
          class: _vm.imageStyle,
          attrs: { alt: "CoteiBem", title: "Ir para página inicial" },
        },
        [
          _vm.isDarkMode && !_vm.businessMode && !_vm.flat
            ? _c("source", {
                attrs: {
                  srcset: require("icon/custom/logo-color-white-horizontal.svg"),
                },
              })
            : _vm._e(),
          _vm._v(" "),
          !_vm.isDarkMode && !_vm.businessMode && !_vm.flat
            ? _c("source", {
                attrs: {
                  srcset: require("icon/custom/logo-color-dark-horizontal.svg"),
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.businessMode && !_vm.flat
            ? _c("source", {
                attrs: {
                  srcset: require("icon/custom/logo-business-color-light-horizontal.svg"),
                },
              })
            : _vm._e(),
          _vm._v(" "),
          !_vm.isDarkMode && !_vm.businessMode && _vm.flat
            ? _c("source", {
                attrs: { srcset: require("icon/custom/logo-flat.svg") },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.flat
            ? _c("source", {
                attrs: { srcset: require("icon/custom/logo-flat.svg") },
              })
            : _vm._e(),
          _vm._v(" "),
          _c("img", {
            staticClass: "c-headerLogo_image",
            class: _vm.imageStyle,
            attrs: {
              src: require("icon/custom/logo-color-mono.svg"),
              width: "180",
              height: "40",
              alt: "Logo do Coteibem",
              title: "Ir para página inicial",
            },
          }),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }